import trainTime from '../lib/TrainTime';
import FeatureFlagStore from '../stores/FeatureFlagStore';
import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';
import FavouritesService from '../services/FavouritesService';

class FavouritesActions {

    _requestAllPending = false;

    async add (fare, orderTrip, delivery, user, context) {
        /*
         * context passed in for analytics
         */
        const favourite = await FavouritesService.addFavourite(fare, orderTrip, delivery, user);
        AppDispatcher.dispatch({
            actionType: ActionTypes.FAVOURITES_ADDED,
            favourite,
            context
        });
    }

    async remove (favourite, user, context) {
        /*
         * context passed in for analytics
         */
        await FavouritesService.removeFavourite(favourite, user);
        AppDispatcher.dispatch({
            actionType: ActionTypes.FAVOURITES_REMOVED,
            favourite,
            context
        });
    }

    async getAll (user) {
        if (this._requestAllPending || !FeatureFlagStore.get('enableFavouriteTickets') || !user) {
            return;
        }
        this._requestAllPending = true;
        try {
            const favourites = await FavouritesService.getFavourites(user);
            AppDispatcher.dispatch({
                actionType: ActionTypes.FAVOURITES_LOADED,
                favourites
            });
        } catch (e) {
            console.error('Failed to load favourites', e);
        } finally {
            this._requestAllPending = false;
        }
    }

    async updatePhotocard (favourite, photocardNumber, user) {
        const updatedFavourite = await FavouritesService.updateFavouritePhotocard(favourite, photocardNumber, user);
        AppDispatcher.dispatch({
            actionType: ActionTypes.FAVOURITES_PHOTOCARD_UPDATED,
            favouriteId: favourite.id,
            photocard: updatedFavourite.photocard
        });
    }

    async addDelivery (favourite, delivery, user) {
        const { id, fulfilment } = await FavouritesService.addFavouriteDelivery(favourite, delivery, user);
        AppDispatcher.dispatch({
            actionType: ActionTypes.FAVOURITES_DELIVERY_ADDED,
            favouriteId: favourite.id,
            deliveryId: id,
            delivery: fulfilment
        });
    }

    async updateDelivery (favourite, delivery, user) {
        const updatedDelivery = await FavouritesService.updateFavouriteDelivery(favourite, delivery, user);
        AppDispatcher.dispatch({
            actionType: ActionTypes.FAVOURITES_DELIVERY_UPDATED,
            favouriteId: favourite.id,
            delivery: updatedDelivery
        });
    }

    async updateSeasonExpiryDate (favourite, user, seasonExpiryDate) {
        await FavouritesService.updateFavouriteSeasonExpiryDate(favourite, seasonExpiryDate, user);
        AppDispatcher.dispatch({
            actionType: ActionTypes.FAVOURITES_SEASON_EXPIRY_DATE_UPDATED,
            favouriteId: favourite.id,
            seasonExpiryDate
        });
    }

    async updateLastUsedDate (favourite, user, lastUsedDate = trainTime()) {
        await FavouritesService.updateFavouriteLastUsedDate(favourite, lastUsedDate, user);
        AppDispatcher.dispatch({
            actionType: ActionTypes.FAVOURITES_LAST_USED_DATE_UPDATED,
            favouriteId: favourite.id,
            lastUsedDate
        });
    }

    async addToBasket (success) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.FAVOURITE_ADDED_TO_BASKET,
            success
        });
    }
}

export default new FavouritesActions();



// WEBPACK FOOTER //
// ./src/actions/FavouritesActions.js